import type { SpartacuxStateWithCustomerFinanceOperations } from '../../interfaces/CustomerFinanceOperationsState';
import type { PaymentPageDetails } from '../PaymentPage.model';

export const selectPaymentPage = (
  state: SpartacuxStateWithCustomerFinanceOperations,
) => state.customerFinanceOperations?.paymentPage;

export const selectPaymentPageDetails = (
  state: SpartacuxStateWithCustomerFinanceOperations,
): PaymentPageDetails | undefined => selectPaymentPage(state)?.details;
